import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragIndicator } from '@mui/icons-material';
import { Checkbox, FormControlLabel, IconButton, MenuItem } from '@mui/material';
import { Column } from '@tanstack/react-table';
import React from 'react';

interface StyledToolbarMenuItemProps<TData> {
  column: Column<TData, unknown>;
  isDndEnabled?: boolean;
}

function StyledToolbarMenuItem<TData>(props: StyledToolbarMenuItemProps<TData>) {
  const id = props.column.id;

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled: !props.isDndEnabled,
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    cursor: 'default',
  };

  return (
    <MenuItem
      ref={props.isDndEnabled ? setNodeRef : undefined}
      dense
      key={`visibility-${id}`}
      sx={{ width: '100%' }}
      style={props.isDndEnabled ? style : undefined}
      disableTouchRipple
    >
      {props.isDndEnabled && (
        <IconButton
          aria-label={`column-order-${props.column.columnDef.header}`}
          data-testid={`column-order-button-${props.column.columnDef.header}`}
          size='small'
          edge='start'
          sx={{ cursor: 'grab', p: 0 }}
          {...attributes}
          {...listeners}
        >
          <DragIndicator fontSize='small' />
        </IconButton>
      )}
      <FormControlLabel
        sx={{ width: '100%', m: 0 }}
        control={
          <Checkbox
            color='default'
            sx={{ p: 0.5, mr: 0.5 }}
            size='small'
            checked={props.column.getIsVisible()}
            onChange={props.column.getToggleVisibilityHandler()}
          />
        }
        label={String(props.column.columnDef.header)}
      />
    </MenuItem>
  );
}

export default StyledToolbarMenuItem;
